import React from 'react'
import { isFeatureEnabled, getCurrencySymbol } from 'src/utils'

const renderTitle = symbol => {
  return <div>{symbol}</div>
}

export function formInput(props) {
  const {
    isCheckOutPage = false,
    value = '',
    onChange,
    onBlur,
    onFocus,
    isAppliedTextShown = false,
    enableStoreCreditFlooredValue = false,    
  } = props
  const enableStoreCreditCurrencyFormat = isFeatureEnabled(
    'enableStoreCreditCurrencyFormat'
  )
  const storeCreditCurrencySymbol = enableStoreCreditCurrencyFormat
    ? getCurrencySymbol()
    : '$'
  const fieldConfig = []
  // let checkoutStoreCreditField = []
  const storeCreditDollarLabel = {
    name: 'storeCreditTitle',
    isToHideLabel: true,
    dataTestId: 'qa-storeCredit-title',
    maxLength: '64',
    columnType: {
      lg: '0',
      sm: '0',
      xs: '0',
    },
    customClassName: 'mb-2 p-2 text-right pr-2',
    ariaLabel: 'storeCredit',
    RenderProps: renderTitle(storeCreditCurrencySymbol),
    //placeholderKey: 'checkoutCouponOrPromotional',
  }
  const storeCreditInputField = {
    name: 'storeCredit',
    isToHideLabel: true,
    dataTestId: 'qa-storeCredit',
    maxLength: '64',
    columnType: {
      lg: isCheckOutPage ? (isAppliedTextShown ? '4' : '5') : '10',
      sm: isCheckOutPage ? (isAppliedTextShown ? '4' : '5') : '10',
      xs: isCheckOutPage ? (isAppliedTextShown ? '4' : '5') : '10',
    },
    customClassName: 'mb-2 p-0',
    ariaLabel: 'storeCredit',
    type: 'text',
    inputMode: enableStoreCreditFlooredValue ? 'decimal' : 'numeric',
    placeholderKey: 'storeCredit',
    onValueChange: onChange,
    defaultValue: value,
    initValue: { storeCredit: value || '' },
    customAttributes: {
      autoComplete: 'off',
      onBlur,
      onFocus,
    },
  }

  const applyCreditButton = {
    name: 'applyButton',
    type: 'inlineSubmitButton',
    dataTestId: 'qa-store-credit-apply',
    customClassName: 'p-0 mb-2',
    columnType: {
      lg: isCheckOutPage ? (isAppliedTextShown ? '7' : '6') : '11',
      sm: isCheckOutPage ? (isAppliedTextShown ? '7' : '6') : '11',
      xs: isCheckOutPage ? (isAppliedTextShown ? '7' : '6') : '11',
    },
  }

  isCheckOutPage
    ? fieldConfig.push([
        storeCreditDollarLabel,
        storeCreditInputField,
        applyCreditButton,
      ])
    : fieldConfig.push(
        [storeCreditDollarLabel, storeCreditInputField],
        applyCreditButton
      )

  return fieldConfig
}
